// Components==============
import Calender from 'components/UI/Calender/Calender';
import { ProjectProcessContext } from 'components/UI/ProjectProcess/ProjectProcess';
import Token from 'components/UI/Token/Token';
import TrainingCard from 'components/UI/TrainingCard/TrainingCard';
import { useRedux } from 'hooks/useRedux';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext } from 'react';
import { ProcessContext } from '../Process';
import './Top.module.scss';
// =========================

export default function Top() {
  const { editableProcess, process, onbekend } = useContext(ProcessContext);
  const { inModal, isEditable } = useContext(ProjectProcessContext);
  const { handleDeleteActivity } = useContext(ProjectDetailsContext);

  const activityHasEvidence = !!(
    process?.process_type === 'App\\Activity' && process.evidence?.length
  );

  const token = useRedux((state) =>
    editableProcess?.process_type === 'App\\Phase'
      ? state.phase?.entities.byId[editableProcess.id]
      : editableProcess?.process_type === 'App\\Training'
      ? state.training?.entities.byId[editableProcess.id]
      : editableProcess?.process_type === 'App\\Activity'
      ? state.activity?.entities.byId[editableProcess.id]
      : undefined
  );

  return (
    <div
      styleName="wrapper"
      style={{ pointerEvents: inModal ? 'none' : 'all' }}
    >
      {editableProcess?.process_type !== 'App\\Phase' &&
        !isEditable &&
        !inModal && (
          <div styleName="calender">
            <Calender />
          </div>
        )}
      {token && 'thumbnail' in token ? (
        <Token
          token={token}
          process={editableProcess}
          canSwitch={!!isEditable}
          handleDelete={
            isEditable
              ? () =>
                  handleDeleteActivity(
                    editableProcess?.processId,
                    editableProcess?.process_type
                  )
              : undefined
          }
          preventDeleteOrSwitch={activityHasEvidence}
          style={{
            width: editableProcess?.process_type === 'App\\Phase' ? 200 : 175,
            maxWidth: 'initial',
          }}
          onbekend={onbekend}
        />
      ) : (
        <div style={{ width: 175, margin: '0 auto' }}>
          <TrainingCard
            training={token}
            process={editableProcess}
            withModal
            small
            canSwitch={!!isEditable}
            handleDelete={
              isEditable
                ? () =>
                    handleDeleteActivity(
                      editableProcess?.processId,
                      editableProcess?.process_type
                    )
                : undefined
            }
          />
        </div>
      )}
    </div>
  );
}
